import React from 'react';
import './index.scss';
import AllActionType from '../../redux/actionType';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { isEmpty } from '../../utils';
import { StopListItem } from '../../utils/formatType';
import { StopTravelStatus, VehicleScheduleState } from '../../redux/type';
import { api } from '../../fetch/bussiness/api';
const classNames = require('classnames');
interface Props {
  config: {
    iconName: string; // 弹窗icon 'warningIcon' | 'shoutingIcon'
    isOnlyBtn: boolean;
    show: boolean; // isShow弹窗
    submitBtnTxt: string; // btn text
    tipType: string; // 指令操作类型
    cancelBtnTxt?: string;
  };
  handleAction: (value: any) => void;
}
const asArriveConfirmMessage = new Map([
  ['TOLOAD', '是否到达装载点{{X}}？'], // {{X}}占位符
  ['TOUNLOAD', '是否到达卸载点{{X}}？'],
  ['SETOUT', '是否到达停靠点{{X}}？'],
  ['RETURN', '是否到达停靠点{{X}}？'],
]);

const Dialog = (props: Props) => {
  const state = useSelector((state: RootState) => {
    return state.singleVehiclePageInfo;
  });
  const { stopList } = state.scheduleRealTime;
  const { scheduleState } = state.vehicleRealTimeInfo;

  let title = '是否到达停靠点？';
  if (!isEmpty(stopList)) {
    let confirmMessageInfo =
      asArriveConfirmMessage.get(scheduleState) || '是否到达停靠点？';
    const nextStopInfo = stopList.find(
      (item: StopListItem) => item.travelStatus == 'START',
    );

    if (nextStopInfo && nextStopInfo.name) {
      confirmMessageInfo = confirmMessageInfo.replace(
        /{{X}}/g,
        nextStopInfo.name,
      );
    }
    title =
      nextStopInfo &&
      !isEmpty(stopList) &&
      nextStopInfo.travelStatus === StopTravelStatus.START
        ? confirmMessageInfo
        : '是否到达停靠点？';
  }

  const { config } = props;
  const { tipType } = config;
  // 提示titleMap
  const titleMessageMap = new Map([
    ['takeover', '是否确定恢复？'],
    ['reStart', '是否确定远程重启？'],
    ['control', '是否确定远程遥控？'],
    ['arrived', title],
  ]);
  // 指令map
  const eventType = new Map([
    ['takeover', api.recovery],
    ['reStart', api.restart],
    ['control', 'remoteControl'],
    ['arrived', api.asArrived],
    ['POWER_OFF', api.powerOff],
    ['REBOOT', api.reboot],
  ]);
  const onCancel = () => {
    props.handleAction &&
      props.handleAction({
        isShow: false,
        eventType: null,
      });
  };
  /**
   * 确认下发指令
   */
  const onConfirm = () => {
    props.handleAction &&
      props.handleAction({
        isShow: true,
        eventType: eventType.get(tipType) || null,
      });
  };
  return (
    <div className={classNames('com-dialog-mask', { hide: !config.show })}>
      <div className='com-dialog'>
        <div className='com-dialog-close-btn' onClick={onCancel}></div>
        <div className='com-dialog-conent'>
          <div
            className={classNames({
              'warning-icon': config.iconName == 'warningIcon',
              'shouting-icon': config.iconName == 'shoutingIcon',
            })}
          ></div>
          {config && (
            <div
              className='com-dialog-tip'
              dangerouslySetInnerHTML={{
                __html: titleMessageMap.get(tipType) || '',
              }}
            />
          )}
        </div>
        <div className='com-dialog-btns-wrap'>
          {!config.isOnlyBtn && (
            <div
              onClick={onCancel}
              className='com-dialog-btn cancel-dialog-btn'
            >
              {config.cancelBtnTxt || '取消'}
            </div>
          )}
          <div onClick={onConfirm} className='com-dialog-btn submit-dialog-btn'>
            {config.submitBtnTxt || '确定'}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Dialog;
